import { Box, Typography, Paper } from "@mui/material";
import PropTypes from 'prop-types';

export default function ErrorFallback({ error, resetErrorBoundary }) {
    const handleRefresh = () => {
        window.location.reload();
    }

    return (
        <Paper  style={{ padding: 32, margin: "40px auto", maxWidth: 600, backgroundColor:"transparent",boxShadow:"none" }}>
            <Box textAlign="center" sx={{display: "flex", flexDirection:"column", alignItems:"center"}}>
                <Typography 
                sx={{
            color: "#021227",
            textAlign: "center",
            fontFamily: "Nunito Sans",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "24px",
            letterSpacing: "0.15px",
          }}>
                    Something went wrong.
                </Typography>
                <Typography
                    sx={{
            color: "#021227",
            textAlign: "center",
            fontFamily: "Nunito Sans",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
            letterSpacing: "0.15px",
            maxWidth: "25rem",
            paddingTop:"1rem"
          }}
                >
                Please try after some time
                </Typography>
                <Typography
          component="button"
          onClick={handleRefresh}
          sx={{
            mt: 1,
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#005BFF",
            fontFamily: "Nunito Sans",
            fontSize: "14px",
            fontWeight: 600,
            letterSpacing: "0.2px",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            transition: "color 0.2s ease",
            "&:hover": {
              color: "#003EA8",
            },
          }}
        >
          Refresh
        </Typography>
            </Box>
        </Paper>
    );
}

ErrorFallback.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
  error: PropTypes.object,
};